<template>
    <div>

        <div class="container">

            <div class="breadcrumbs">
                <ul>
                    <li>
                        <a href="#" @click="getSoundClick(); $router.go(-1)">
                            <i class="lisa-icon-back"></i>
                        </a>
                    </li>
                    <li>
                        <div class="btn-group nav" role="tablist">
                            <button class="btn btn-primary active" id="nav-avatar-tab">{{ $t('daily_challenge') }}</button>
                            <router-link :to="{path: '/daily-bonus'}" @click.native="getSoundClick">
                                <button class="btn btn-primary" id="nav-emoticon-tab">{{ $t('daily_bonus') }}</button>
                            </router-link>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="tab-content">
                <div class="tab-pane fade show active" id="nav-avatar" role="tabpanel" aria-labelledby="nav-avatar-tab">

                    <div class="card card-daily-challenge">
                        <div class="card-header">
                            <div class="card-title">{{ $t('daily_challenge') }}</div>
                        </div>
                        <div class="card-body">
                            <div class="d-flex">
                                <div class="flex" style="margin-right: 240px">
                                    <div>{{ $t('daily_challenge_1') }}</div>
                                </div>
                                <div>
                                    <button class="btn btn-key-collection">
                                        <p class="d-flex"> <span style="font-size:12px">{{ $t('key_collected') }}</span>: <span style="font-size:20px; margin-left:5px"> {{ key_collect }}</span> <i class="lisa-icon-lock-1"></i></p>
                                        <p style="font-size:12px"> <span>{{ $t('reset_in') }}</span>: <b>{{ time_remain_txt }}</b> </p> 
                                    </button>
                                </div>
                            </div>

                            <div class="daily-challenge">
                                <div class="daily-challenge-items">

                                    <template v-for="(challenge, index) in challenges">
                                        <daily-challenge-item :challenge="challenge" @updateNewChallenge="updateNewChallenge"/>
                                    </template>

                                </div>
                            </div>

                            <div class="daily-challenge-boxes">
                                <div class="row">
                                    <div class="swiper-container-11" id="scroll-tags">
                                        <ul class="swiper-wrappe-1">
                                            <div class="swiper-slide" style="display: flex">
                                                <div v-for="(mission, index) in missions" :key="index">
                                                    <daily-challenge-mission-item :mission="mission" @updateNewMission="updateNewMission" @updateNewChallenge="updateNewChallenge"/>
                                                </div>
                                            </div>
                                        </ul>
                                        <!-- <div class="swiper-scrollbar"></div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="tab-pane fade" id="nav-emoticon" role="tabpanel" aria-labelledby="nav-emoticon-tab">

                </div>
            </div>

            <!-- <div class="modal fade modal-flex" id="addGem" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="dailyBonusModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 539px; max-width: 539px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">{{$t('congratulation')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="">
                                <div class="daily-bonus-gem" style="display: flex;justify-content: space-evenly;background:none;flex-direction: column">
                                    <img src="/themes/ito/images/get-rewarded.svg" alt="">
                                    <div style="display: flex;align-items: center;justify-content: space-around;">
                                        <div class="text-2" style="color:black">+ {{gem30}}</div>
                                        <div class="gem">
                                            <i class="lisa-icon-gem-large"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="daily-bonus-content">
                                    {{$t('daily_bonus_msg')}}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button  @click="claim" type="button" class="btn btn-main-border m-auto" style="padding: 8px 15px;">{{$t('ok')}}</button>
                        </div>
                    </div>
                </div>
            </div> -->
            <get-reward-modal/>
            <get-reward-lock-modal/>
        </div>
    </div>
</template>

<script>
    import {getDailyChallenge} from '../../models/reward'
    import {showDialog} from '../../utils/dialog'
    import {mapGetters} from 'vuex'
    import {pushQueries, soundClick, convertSecondToText} from "../../utils/utils";
    import axios from "axios";
    import {getInboxs} from "../../models/inbox";
    import DailyChallengeItem from "./DailyChallengeItem";
    import DailyChallengeMissionItem from "./DailyChallengeMissionItem";
    import GetRewardModal from "../modal/GetRewardModal";
    import GetRewardLockModal from "../modal/GetRewardLockModal";
    import {claimDailyBonusAdd} from "../../models/reward";

    export default {

        name: "DailyChallenge",
        components: {GetRewardModal, DailyChallengeMissionItem, DailyChallengeItem, GetRewardLockModal},
        title: 'Daily challenge',

        data() {
            return {
                challenges: [],
                missions: [],
                key_collect: 0,
                isLoading: true,
                time_remain: 0,
                time_remain_txt: '00:00:00',
                isLoading: true
            };
        },

        created() {
            this.fetch();
        },

        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return this.user
            })
        },

        watch: {
            time_remain: {
                handler(value) {

                    if (value > 0) {
                        setTimeout(() => {
                            this.time_remain--;

                            this.time_remain_txt = convertSecondToText(this.time_remain) || '';
                        }, 1000);
                    }

                },
                immediate: true // This ensures the watcher is triggered upon creation
            },
        },

        methods: {
            async fetch() {
                const that = this;

                await axios.all([
                    getDailyChallenge(),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;

                    if (response.data.code != 0) {
                        return;
                    }

                    that.challenges = response.data.results.challenge || [];
                    that.missions = response.data.results.mission || [];
                    that.key_collect = response.data.results.key_collect || 0;
                    that.time_remain = response.data.results.time_remain || 0;

                    console.log(response.data.results);


                    this.$nextTick(function () {
                        that.initSwiper();
                    });

                }));
            },

            getSoundClick() {
                soundClick();
            },

            updateNewChallenge(challenges, key_collect) {
                this.challenges = challenges;
                this.key_collect = key_collect;
            },

            updateNewMission(new_key_collect, new_mission_id, new_mission_status) {
                //this.missions = new_mission;
                this.key_collect = new_key_collect;
                this.missions.forEach(element => {
                    if (element.id == new_mission_id) {
                        element.status = new_mission_status;
                    }
                });
            },

            initSwiper() {
                return new Swiper(".swiper-container", {
                    slidesPerView: "auto",
                    freeMode: true,
                    slideToClickedSlide: true,
                    spaceBetween: 0,
                    scrollbar: {
                        el: ".swiper-scrollbar",
                        draggable: true
                    },
                    mousewheel: true
                });
            },
        }
    }
</script>

<style scoped>
    .swiper-container {
        width: 100%;
        height: auto;
        padding-bottom: 30px !important; /*space for the scrollbar*/
    }

    ul.swiper-wrapper {
        padding: 0;
    }

    .swiper-slide {
        overflow: auto;
        width: auto !important;;
    }

    .swiper-slide--item{
        width: 202px;
    }

    /* .container{
        width: 940px;
        padding: 0;
    } */

    .btn-key-collection p{
        margin: 0;
    }
    .btn-key-collection{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>
